import { createSlice } from '@reduxjs/toolkit';

const initialState = '';

const currentRutasTabStateSlice = createSlice({
	name: 'currentRutasTabState',
	initialState,
	reducers: {
		setCurrentRutasTabState: (state, action) => {
			return action.payload;
		},
		resetCurrentRutasTabState: () => initialState
	}
});

export const { setCurrentRutasTabState, resetCurrentRutasTabState } = currentRutasTabStateSlice.actions;
export default currentRutasTabStateSlice.reducer;
